module.exports = __webpack_public_path__ + "static/media/MCM_Logos-01.87a690af.png";